// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const LastContactDetails = t.struct({
    lastContactDate: t.maybe(t.Number),
    letterSentDate: t.maybe(t.Number)
}, {
    name: 'LastContactDetails',
    strict: true
});

export const getDefaultState = () => new LastContactDetails({
    lastContactDate: null,
    letterSentDate: null
});

export default LastContactDetails;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/lastcontact-details.js